import useLocaleText from 'components/useLocaleText'
export const categoryPickerLiterals = {
  title: { key: 'task_creation_add_categories', fallback: { en: 'Add categories', he: 'הוספת קטגוריות' } },
  hint: {
    key: 'task_creation_add_categories_hint',
    fallback: {
      en: 'Pick existing ones or type a new name to create it. You can add several at once.',
      he: 'בחרו קטגוריות קיימות או הקלידו שם חדש. ניתן להוסיף כמה בבת אחת.',
    },
  },
  search: {
    key: 'task_creation_search_create_category',
    fallback: { en: 'Search or create a category', he: 'חיפוש או יצירת קטגוריה' },
  },
  alreadyAdded: { key: 'task_creation_category_already_added', fallback: { en: 'Already in task', he: 'כבר במשימה' } },
  nothing: {
    key: 'task_creation_no_categories_selected',
    fallback: { en: 'Nothing selected', he: 'לא נבחרו קטגוריות' },
  },
  selected: { key: 'task_creation_categories_selected', fallback: { en: '{count} selected', he: '{count} נבחרו' } },
  addOne: { key: 'add_category', fallback: { en: 'Add category', he: 'הוספת קטגוריה' } },
  addMany: {
    key: 'task_creation_add_category_count',
    fallback: { en: 'Add {count} categories', he: 'הוספת {count} קטגוריות' },
  },
  create: { key: 'task_creation_create_category_name', fallback: { en: 'Create “{name}”', he: 'יצירת ״{name}״' } },
  cancel: { key: 'cancel', fallback: { en: 'Cancel', he: 'ביטול' } },
}
export const useCategoryPickerText = () => useLocaleText(categoryPickerLiterals)
